<template>
    <div class="row">

        <div class="col-md-12">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link :to="{name:'cajas-online'}">{{$t("cajasOnline")}}</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link :to="{name:'online-detail', params:{idBusiness: idBusiness}}">
                            {{onlineDetails.nameBusiness}}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">{{$t("productos")}}</li>
                </ol>
            </nav>
        </div>

        <div class="col-md-12"style="margin-bottom: 2px">
            <el-button-group>
                <el-button size="small"  @click="prodSub=false, getProductosMasVendidos()"><i class="fas fa-th-large"></i> {{$t("productos")}}</el-button>
                <el-button size="small"  @click="prodSub=true,getSubproductMasVendidos()"><i class="fas fa-th-list"></i> {{$t("subproductos")}}</el-button>
            </el-button-group>
        </div>
        <div class="col-md-8">
            <table class="table table-bordered table-striped">
                <thead class="thead-dark">
                <tr>
                    <th>{{$t("productos")}}</th>
                    <th>{{$t("uds")}}.</th>
                    <th v-if="!prodSub">{{$t("importe")}}</th>
                    <th v-if="!prodSub">{{$t("precioMedio")}}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="product in products">
                    <td>{{product.product}}</td>
                    <td>{{Math.abs(product.units)}}</td>
                    <td v-if="!prodSub" align="right">{{product.import | currency}}</td>
                    <td v-if="!prodSub" align="right">{{(product.import / product.units) | currency}}</td>
                </tr>
                </tbody>
                <tfoot>
                <tr class="table-success" v-if="!prodSub">
                    <td><strong>{{$t("total")}}:</strong></td>
                    <td></td>
                    <td align="right"><strong>{{getTotal | currency}}</strong></td>
                    <td></td>
                </tr>
                </tfoot>
            </table>
        </div>

        <div class="col-md-4">
            <canvas id="chart"></canvas>
        </div>
    </div>
</template>
<script>

    import swal from 'sweetalert2'
    import {Switch,ButtonGroup,Button} from 'element-ui'

    export default {
        created() {
            this.$store.dispatch("setNameRoute", this.$i18n.t("cajasOnlineProductos"));
            this.getOnlineDetails();
        },
        data() {
            return {
                idBusiness: this.$route.params.idBusiness,
                onlineDetails: {},
                products: [],
                subproducts:[],

                objectChart: null,
                contador: 0,

                prodSub:false,
            }
        },
        components: {
            [Button.name]: Button,
            [Option.name]: Option,
            [ButtonGroup.name]:ButtonGroup
        },
        computed:{
            getTotal(){
                var total = 0;

                this.products.forEach(function (p){
                   total += p.import;
                });
                return total;
            }
        },
        methods: {
            getOnlineDetails() {
                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "online/getOnlineDetails", config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.onlineDetails = response.data.result;
                            vm.getProductosMasVendidos();
                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            getSubproductMasVendidos(){


                var tpvs = [];
                this.onlineDetails.listTpvs.forEach(function (x) {
                    if (x && x.online) {
                        tpvs.push(x.idTpv);
                    }
                });


                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        listTpv: JSON.stringify(tpvs),
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "online/getSubProductsStats", config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.products = response.data.result.listSubproducts;
                            vm.initChart();
                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            getProductosMasVendidos() {

                var tpvs = [];
                this.onlineDetails.listTpvs.forEach(function (x) {
                    if (x && x.online) {
                        tpvs.push(x.idTpv);
                    }
                });


                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        listTpv: JSON.stringify(tpvs),
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "online/getProductosMasVendidos", config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.products = response.data.result.listProducts;
                            vm.initChart();
                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            initChart() {


                var labels = this.products.map(function (x) {
                    return x.product;
                });

                var data = this.products.map(function (x) {
                    return x.units;
                });


                var randomColor = require('randomcolor');

                var colors = randomColor({luminosity: 'dark', count: labels.length, format: 'rgb'});

                let backgroundColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.6)";
                });

                let borderColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.3)";
                });

                let hoverBackgroundColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 1)";
                });

                if (this.contador == 0) {

                    if (this.products.length > 0) {
                        this.objectChart = new Chart("chart", {

                            type: 'pie',
                            data: {
                                labels: labels,
                                datasets: [{
                                    data: data,
                                    backgroundColor: backgroundColors,
                                    borderColor: borderColors,
                                    hoverBackgroundColor: hoverBackgroundColors,
                                    borderWidth: 1
                                }]
                            },
                            options: {
                                legend: {
                                    display: true,
                                    position: 'bottom',


                                },


                            }
                        });


                        this.contador++;
                    }
                }
                else {

                    this.objectChart.destroy();

                    this.objectChart = new Chart("chart", {

                        type: 'pie',
                        data: {
                            labels: labels,
                            datasets: [{
                                data: data,
                                backgroundColor: backgroundColors,
                                borderColor: borderColors,
                                hoverBackgroundColor: hoverBackgroundColors,
                                borderWidth: 1
                            }]
                        },
                        options: {
                            legend: {
                                display: true,
                                position: 'bottom'
                            },


                        }
                    });

                }

            }

        }
    }
</script>
<style scoped>
    .card-body {
        padding: 10px 15px;
    }

    #tabletotalventa td {
        padding: 5px 15px;
    }

    .wrap-chart {
        margin-top: 10px;
        padding: 0px;
    }

    .foot-total tr td {
        font-size: 1.2em;
        color: #fff;
        text-shadow: 1px 1px #111;
        font-weight: bold;
    }

    .check-tpv {
        padding-left: 1em;
    }

    .check-tpv label {
        margin-bottom: 0px;
    }

    .check-tpv label:hover {
        cursor: pointer;
    }

    .progress {
        height: 10px !important;
        margin-bottom: 0px;
    }

    .progresstpv td {
        border-top: none;
    }

    .card-columns {
        column-count: 2;

    }

    @media (max-width: 767.98px) {
        .card-columns {
            column-count: 1;

        }
    }


</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Online/OnlineProducts.vue